
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { END_LOADING, START_LOADING } from '@/main/store/listEditTypes';

import { depTableNames, NAME, CRUMB_LABEL_KEY, VOZIDLO_OZN_AUDI } from '../constants';
import { apiProvider } from '../api';
import { editMutations, editActions } from './types';
import { NAME as ODHADY_PRACNOSTI_PODIL } from '../../odhadyPracnostiPodil/constants';

const edit = {
	ZaznamId: null as number | null,
	PpookruhId: null as number | null,
	VyrobekvozOzn: null as string | null,
	Tablpozice: null as string | null,
	TablpoziceText: null as string | null,
	CasJdnPocC: null as number | null,
	Text: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EmisePzn: null as number | null,
	EditPrp: null as number | null,
	Poznamka: null as string | null,
	OzakazkobjPrp: null as number | null,
	OzakazkobjIntPrp: null as number | null,
	PcPevna: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		EmisePzn: [],
		PpookruhId: [],
		Tablpozice: [],
		VyrobekvozOzn: [],
	},
	depTableNames,
	depTableSettings: {
		[ODHADY_PRACNOSTI_PODIL]: {
			filter(state) {
				return { PpodhadId: state.edit.ZaznamId };
			},
		},
	},
	edit,
	localState: {
		TablpoziceRows: [],
		TablpoziceKlon: [] as number[],
		VyrobekvozOznKlon: VOZIDLO_OZN_AUDI,
	},
	extraActions: {
		[editActions.FETCH_TABULKOVA_POZICE]: async ({ state, commit }) => {
			try {
				commit(START_LOADING);
				const res = await apiProvider.fetchTabulkovaPozice({ VyrobekvozOzn: state.localState.VyrobekvozOznKlon! });
				commit(editMutations.SET_TABULKOVA_POZICE, res);
			} finally {
				commit(END_LOADING);
			}
		},
	},
	extraMutations: {
		[editMutations.TABULKOVA_POZICE_SELECT_MAPPER](state, { data }) {
			state.edit.Tablpozice = data.value;
		},
		[editMutations.SET_TABULKOVA_POZICE](state, { data }) {
			state.localState.TablpoziceRows = data;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
